import { forwardRef } from 'react';
import { TextField, useLocalization, useMasterData } from '@ui-framework/index';
import { InputAdornment } from '@mui/material';
import getSMSSubscriptionAttributes from '../lib/getSMSSubscriptionAttributes';
import InsightChipWithToolTip from '../InsightChipWithToolTip';
import formatUSPhoneNumber from '../lib/formatUSPhoneNumber';

const PhoneTextField = forwardRef((props, ref) => {
  const { insightProps, ...rest } = props;
  const { formatMessage } = useLocalization();
  const masterData = useMasterData();

  let status = null;
  if (insightProps?.smsSubscriptionStatus) {
    status = getSMSSubscriptionAttributes(
      insightProps?.smsSubscriptionStatus,
      formatUSPhoneNumber(masterData.saPhoneNumber),
      formatMessage,
    );
  }

  return (
    <TextField
      {...rest}
      inputRef={ref}
      fullWidth
      inputProps={{ maxLength: 14 }}
      slotProps={
        insightProps?.smsSubscriptionStatus
          ? {
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <InsightChipWithToolTip status={status} />
                  </InputAdornment>
                ),
              },
            }
          : undefined
      }
    />
  );
});

export default PhoneTextField;
